import React from 'react';
import classNames from 'classnames';
import { withNativeProps } from '../../utils/native-props';
import { withDefaultProps } from '../../utils/with-default-props';
var classPrefix = "adm-space";
export var Space = withDefaultProps({
  direction: 'horizontal'
})(function (props) {
  var _classNames;

  var size = props.size,
      direction = props.direction;
  var sizeStyle = {};

  if (size) {
    var _ref = Array.isArray(size) ? size : [size, size],
        horizontalSize = _ref[0],
        verticalSize = _ref[1];

    sizeStyle = {
      '--vertical-size': typeof verticalSize === 'number' ? verticalSize + "px" : verticalSize,
      '--horizontal-size': typeof horizontalSize === 'number' ? horizontalSize + "px" : horizontalSize
    };
  }

  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classNames(classPrefix, (_classNames = {}, _classNames[classPrefix + "-wrap"] = props.wrap, _classNames[classPrefix + "-block"] = props.block, _classNames[classPrefix + "-" + direction] = true, _classNames[classPrefix + "-align-" + props.align] = !!props.align, _classNames[classPrefix + "-justify-" + props.justify] = !!props.justify, _classNames)),
    style: sizeStyle
  }, React.Children.map(props.children, function (child) {
    return child !== null && child !== undefined && /*#__PURE__*/React.createElement("div", {
      className: classPrefix + "-item"
    }, child);
  })));
});